import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7667558d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "date-list" }
const _hoisted_3 = { class: "read-more-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleOrderListItem = _resolveComponent("SimpleOrderListItem")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_ctx.isShownUpcomingApplicableOrders)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", {
          class: _normalizeClass(["text-size-14 text-weight-500 text-primary-dark section-title", _ctx.titleClass])
        }, _toDisplayString(_ctx.title), 3),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
            return (_openBlock(), _createBlock(_component_SimpleOrderListItem, {
              order: order,
              key: order.id
            }, null, 8, ["order"]))
          }), 128))
        ]),
        _createTextVNode(),
        (_ctx.isShownReadMore)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              class: "read-more",
              to: _ctx.readMoreLink
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(`お仕事一覧を見る (全${_ctx.applicableOrderCount}件)`), 1),
                _createTextVNode(),
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "24"
                })
              ], undefined, true),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}